// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Ui from "../../shared/Ui.re.mjs";
import * as React from "react";
import * as HomeAtoms from "../../atoms/home/HomeAtoms.re.mjs";
import * as HomeContent from "../../organisms/home/HomeContent.re.mjs";
import * as LucideReact from "lucide-react";
import * as Core from "@linaria/core";
import * as JsxRuntime from "react/jsx-runtime";

import { css, cx } from '@linaria/core'
;

import { t } from '@lingui/macro'
;

function portraitParams() {
  return {
    auto: "enhance,compress",
    fit: "crop",
    crop: "focalpoint",
    "fp-z": "1.1"
  };
}

function HomeMolecules$SampleFigure(props) {
  return JsxRuntime.jsxs("figure", {
    children: [
      JsxRuntime.jsx("a", {
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Ui.DImg.make, {
            src: props.src,
            alt: props.alt,
            className: Core.cx("w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]"),
            imgixParams: {
              auto: "enhance,compress",
              fit: "crop",
              crop: "focalpoint",
              "fp-z": "1.1"
            },
            sizes: "(min-width: 768px) 30vw, 50vw",
            width: 480,
            height: 600
          }),
          className: Core.cx("relative", "overflow-hidden", "bg-gray-100", "aspect-[4/5]")
        }),
        className: Core.cx("block"),
        href: props.link
      }),
      JsxRuntime.jsxs("figcaption", {
        children: [
          JsxRuntime.jsx("span", {
            children: HomeAtoms.pad(props.index + 1 | 0),
            className: Core.cx("text-[10px] tracking-widest text-gray-400 font-light tabular-nums")
          }),
          JsxRuntime.jsx("span", {
            children: props.caption,
            className: Core.cx("text-xs text-gray-600 font-light tracking-wide")
          })
        ],
        className: Core.cx("mt-3", "flex", "items-baseline", "gap-3")
      })
    ],
    className: Core.cx("group")
  });
}

let SampleFigure = {
  make: HomeMolecules$SampleFigure
};

function HomeMolecules$IndexedRow(props) {
  return JsxRuntime.jsxs("li", {
    children: [
      JsxRuntime.jsx("span", {
        children: HomeAtoms.pad(props.index + 1 | 0),
        className: Core.cx("font-serif font-light text-sm text-gray-400 tabular-nums")
      }),
      JsxRuntime.jsx("span", {
        children: props.children,
        className: Core.cx("text-gray-700 font-light leading-relaxed flex-1")
      })
    ],
    className: Core.cx("flex items-baseline gap-6 py-5 border-t border-gray-200 last:border-b")
  });
}

let IndexedRow = {
  make: HomeMolecules$IndexedRow
};

function HomeMolecules$ReviewCard(props) {
  let review = props.review;
  let quote = review.quote;
  let src = review.image;
  return JsxRuntime.jsxs("figure", {
    children: [
      src !== undefined ? JsxRuntime.jsx("a", {
          children: JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Ui.DImg.make, {
              src: src,
              alt: review.alt,
              className: Core.cx("w-full h-full object-cover"),
              imgixParams: {
                auto: "enhance,compress",
                fit: "crop",
                crop: "faces"
              },
              sizes: "(min-width: 1024px) 25vw, (min-width: 640px) 50vw, 100vw",
              width: 600,
              height: 450
            }),
            className: Core.cx("relative overflow-hidden bg-gray-100 aspect-[4/3] mb-5")
          }),
          className: Core.cx("block"),
          href: review.link
        }) : null,
      JsxRuntime.jsx("blockquote", {
        children: t`“${quote}”`,
        className: Core.cx("font-serif font-light italic text-lg text-gray-900 leading-snug mb-5 flex-1")
      }),
      JsxRuntime.jsx(HomeAtoms.Stars.make, {
        rating: review.rating
      }),
      JsxRuntime.jsxs("figcaption", {
        children: [
          JsxRuntime.jsx("p", {
            children: review.name,
            className: Core.cx("text-sm font-light text-gray-800")
          }),
          review.date === "" ? null : JsxRuntime.jsx("p", {
              children: review.date,
              className: Core.cx("text-xs text-gray-400 font-light tabular-nums mt-0.5")
            })
        ],
        className: Core.cx("mt-3")
      })
    ],
    className: Core.cx("flex", "flex-col")
  });
}

let ReviewCard = {
  make: HomeMolecules$ReviewCard
};

function HomeMolecules$PressLogo(props) {
  return JsxRuntime.jsx("a", {
    children: JsxRuntime.jsx(Ui.Img.make, {
      src: props.src,
      className: Core.cx("h-5 w-auto"),
      alt: props.alt,
      srcSet: props.srcSet
    }),
    className: Core.cx("block opacity-60 grayscale hover:opacity-100 transition-opacity duration-300"),
    href: HomeContent.pressLink
  });
}

let PressLogo = {
  make: HomeMolecules$PressLogo
};

let subscribe = (function (email, name) {
    try {
      fetch("/users/email-subscribe", {
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        body: "email=" + encodeURIComponent(email) + "&name=" + encodeURIComponent(name),
      }).catch(function () {});
    } catch (e) {}
  });

let trackSignup = (function () {
    try {
      if (typeof window === "undefined") return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "email_list_signup" });
      if (window.analytics && typeof window.analytics.track === "function") {
        window.analytics.track("email_list_signup");
      }
    } catch (e) {}
  });

function HomeMolecules$NewsletterForm(props) {
  let match = React.useState(() => "");
  let setEmail = match[1];
  let email = match[0];
  let match$1 = React.useState(() => "");
  let setHoneypot = match$1[1];
  let honeypot = match$1[0];
  let match$2 = React.useState(() => false);
  let setSubmitted = match$2[1];
  let onSubmit = e => {
    e.preventDefault();
    if (email !== "") {
      subscribe(email, honeypot);
      if (honeypot === "") {
        trackSignup();
      }
      return setSubmitted(param => true);
    }
  };
  if (match$2[0]) {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(HomeAtoms.Eyebrow.make, {
          children: t`Thank You`,
          className: Core.cx("mb-3")
        }),
        JsxRuntime.jsx("p", {
          children: t`You’re on the list — keep an eye on your inbox.`,
          className: Core.cx("font-serif font-light text-xl md:text-2xl text-gray-900 leading-snug")
        })
      ],
      className: Core.cx("border-t border-gray-300 pt-6")
    });
  } else {
    return JsxRuntime.jsxs("form", {
      children: [
        JsxRuntime.jsx("label", {
          children: t`Email Address`,
          className: Core.cx("block text-[10px] tracking-[0.3em] uppercase text-gray-500 font-light mb-4"),
          htmlFor: "newsletter-email"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("input", {
              className: Core.cx("flex-1 bg-transparent text-base md:text-lg font-light text-gray-900 placeholder:text-gray-400 focus:outline-none"),
              id: "newsletter-email",
              name: "email",
              placeholder: t`you@example.com`,
              required: true,
              type: "email",
              value: email,
              onChange: e => {
                let v = e.target.value;
                setEmail(param => v);
              }
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("input", {
                tabIndex: -1,
                autoComplete: "off",
                name: "name",
                type: "text",
                value: honeypot,
                onChange: e => {
                  let v = e.target.value;
                  setHoneypot(param => v);
                }
              }),
              "aria-hidden": true,
              className: Core.cx("absolute left-[-5000px]")
            }),
            JsxRuntime.jsxs("button", {
              children: [
                t`Subscribe`,
                JsxRuntime.jsx(LucideReact.ArrowRight, {
                  size: 14,
                  strokeWidth: 1.5
                })
              ],
              className: Core.cx("inline-flex items-center gap-3 text-xs tracking-[0.25em] uppercase font-light text-gray-900 hover:gap-5 transition-all duration-300 whitespace-nowrap"),
              type: "submit"
            })
          ],
          className: Core.cx("flex items-center gap-6 border-b border-gray-400 pb-3 focus-within:border-gray-900 transition-colors duration-300")
        }),
        JsxRuntime.jsx("p", {
          children: t`No spam. Unsubscribe at any time.`,
          className: Core.cx("mt-4 text-xs text-gray-500 font-light italic")
        })
      ],
      onSubmit: onSubmit
    });
  }
}

let NewsletterForm = {
  make: HomeMolecules$NewsletterForm
};

export {
  portraitParams,
  SampleFigure,
  IndexedRow,
  ReviewCard,
  PressLogo,
  subscribe,
  trackSignup,
  NewsletterForm,
}
/*  Not a pure module */
